import React from 'react'
import request from 'superagent';
import {classifyType, timeoutRedirect} from './Util';
import {URL_COVID} from "../constants/Url";
import {COVID_19_HEALTH_HAZARD_SCORE, COVID_19_RESEARCH} from '../constants/Url'
import { dietText, muscleText} from '../constants/SpecialCoivid19'
import {Link, Redirect} from "react-router-dom";
// import TagManager from 'react-gtm-module'
// import {getTagManagerArgs} from './Util';
export default class Covid19 extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      covid_19_and_genetics: null,
      hereditary_conditions: [],
      sports_and_fitness: null,
      bmi_diets: [],
      isBmiToggleOn: true,
      isSportsToggleOn: true,
      isToggleOn: true,
      winOpen: true,
      winOpen02: true,
      winOpen03: true,
      loaded: true,
    }
    this.handleClick = this.handleClick.bind(this);
    this.showWin = this.showWin.bind(this);
    this.showWin02 = this.showWin02.bind(this);
    this.showWin03 = this.showWin03.bind(this);
  }



  handleClick(e) {
    if (e.target.id === "bmi") {
      this.setState(state => ({
        isBmiToggleOn: !state.isBmiToggleOn,
      }));
    } else if (e.target.id === "sports") {
      this.setState(state => ({
        isSportsToggleOn: !state.isSportsToggleOn,
      }));

    } else if (e.target.id === "show"){
      this.setState(state => ({
        isToggleOn: !state.isToggleOn,
      }));
    }
  }

  handleClickOpen(unit_id){
    const { handleModalOpen } = this.props
    handleModalOpen(unit_id)
  }

  componentWillMount() {
    this.fetchData();
  }

  showWin() {
      this.setState(state => ({
        winOpen: !state.winOpen
      }));
  }

  showWin02() {
      this.setState(state => ({
        winOpen02: !state.winOpen02
      }));
  }

  showWin03() {
      this.setState(state => ({
        winOpen03: !state.winOpen03
      }));
  }

  fetchData() {
      request
          .get(URL_COVID(this.props.access_token, this.props.gender, this.props.kit))
          .set('Content-Type', 'application/json')
          .end((err, res) => {
              if (err) {
                  console.log('error')
              }
              if (!res || !res.body.result) {
                  timeoutRedirect()
              }
              const {covid_19_and_genetics,prevention } = res.body.result;
              const {hereditary_conditions, bmi_diets, sports_and_fitness } = prevention;
              this.setState({
                covid_19_and_genetics,
                hereditary_conditions,
                bmi_diets,
                sports_and_fitness,
                loaded: false
              })
          })
  }


  render() {
    const TypeLink = (title, css) => {
      return <div className={`type ${css}`}>{title}</div>
    }
    if (this.state.covid_19_and_genetics && !Object.keys(this.state.covid_19_and_genetics).length) {
      return (<Redirect
        to={{
          pathname: "/buyapp",
          state: { referrer: "/" }
        }}
      />)
    }

    return (
      <div>
          <div className=" lpwrap">
            <div className="wrap">
              <div className="head_nav"><Link  to={{
                pathname: "/",
                state: { referer: "/" }
              }} ></Link>COVID-19 レポート</div>
              {this.state.loaded ? (
                <div className="rad_field">
                  <img style={{display: "block", margin: "auto"}} src="./image/loading.gif"/> 
                </div>
              ): (
                <div>
              <div className="rad_field -blue">
                <div className="row">
                  <div className="col imgcont">
                    <h1>遺伝子とCOVID-19</h1>
                    {this.state.covid_19_and_genetics ? (<p className="lead">{this.state.covid_19_and_genetics.markup_level_name}</p>) : null}
                    <div className="seeresult">
                    {(this.state.covid_19_and_genetics && this.state.covid_19_and_genetics.unit) ? (
                      <Link
                      className="btn_round"
                      onClick={this.handleClickOpen.bind(this, this.state.covid_19_and_genetics.unit.id)}
                      to={{
                        pathname: "/detail",
                        state: { referer: "/covid" }
                      }}>
                        結果を見る
                        </Link>

                    ) : null}
                      <a className="simplelink" onClick={this.showWin03}>参考文献</a>
                    </div>
                  </div>
                  <div className="col textcont">

                    <div className="box_line">
                    <a href={COVID_19_HEALTH_HAZARD_SCORE} target="_blank" rel="noopener noreferrer"><h3>COVID-19ハザードスコア</h3>
                      <p>あなたの健康状態に基づいてCOVID-19重症化や関連する健康上のリスクについて評価します。</p></a>
                    </div>
                    <div className="box_line">
                    <a href={COVID_19_RESEARCH} target="_blank" rel="noopener noreferrer"><h3>COVID-19の研究</h3>
                      <p>あなたの健康状態に基づいてCOVID-19重症化や関連する健康上のリスクについて評価します。参加していただける場合には、ここをクリックしてください。</p></a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="rad_field">
                <h1 className="text-center">新型コロナウィルスとパンデミック</h1>
                <p className="text-center text_gray">パンデミックはいずれは過ぎ去りますが、あなたの潜在的な遺伝的リスクと生活習慣病を理解することで、将来もパンデミックを乗り越え、予防とより健康的な将来に向けて進むことができます。 </p>
                <div className="row">
                  <div className="col">
                    <h2>遺伝性疾患と<br className="pconly" />生活習慣病</h2>
                    <div onClick={this.handleClick} className={this.state.isToggleOn ? 'showlimited' : 'showlimited -open'}>
                      <ul className="box_covid">
                      {(this.state.hereditary_conditions ? this.state.hereditary_conditions.map(data =>
                        <li key={data.id}>
                          <Link
                            onClick={this.handleClickOpen.bind(this, data.unit.id)}
                            to={{
                              pathname: "/detail",
                              state: { referer: "/covid" }
                            }}>
                          <div className="cate">{data.unit.categories[0].name}</div>
                          <div className="name">{data.unit.name}</div>
                          <div className="level">{data.markup_level_name}</div>
                        </Link>
                      </li>
                      ): null)}
                      </ul>
                      <p className="showall" id="show">詳細 ▼</p>
                    </div>
                  </div>
                  <div className="col spmgt">
                    <h2>BMIと食事</h2>
                    <ul className="box_covid">
                    {(this.state.bmi_diets ? this.state.bmi_diets.filter(data => (data.unit.id !== 947 && data.unit.id !== 948)).map(data =>
                      <li key={data.id}>
                          <Link
                            onClick={this.handleClickOpen.bind(this, data.unit.id)}
                            to={{
                              pathname: "/detail",
                              state: { referer: "/covid" }
                            }}>
                            <div className="cate">{data.unit.categories[0].name}</div>
                            <div className="name">{data.unit.name}</div>
                            <div className="level">{data.markup_level_name}</div>
                          </Link>
                      </li>
                    ): null)}
                    {(this.state.bmi_diets ? this.state.bmi_diets.filter(data => (data.unit.id === 947 || data.unit.id === 948)).map(data =>
                      <li key={data.id}>
                      <div className="typetitle" onClick={this.showWin}>あなたの遺伝子型ダイエットタイプから学びましょう</div>
                        {classifyType([94702,94802], data) ? (TypeLink("りんご型", "-apple")) : null }
                        {classifyType([94704,94804], data) ? (TypeLink("バナナ型", "-banana")) : null }
                        {classifyType([94703,94803], data) ? (TypeLink("洋なし型", "-pear")) : null }
                        {classifyType([94701,94801], data) ? (TypeLink("アダムとイブ型", "-adameve")) : null }
                        <div id="bmi">
                          <p className="text_gray">
                          {classifyType([94702,94802], data) ? dietText().apple : null }
                          {classifyType([94704,94804], data) ? dietText().banana : null }
                          {classifyType([94703,94803], data) ? dietText().pear : null }
                          {classifyType([94701,94801], data) ? dietText().adameve : null }
                          <br/><br/>
                          <Link
                            onClick={this.handleClickOpen.bind(this, data.unit.id)}
                            to={{
                              pathname: "/detail",
                              state: { referer: "/covid" }
                            }}>
                            結果を見る
                          </Link>
                          </p>
                        </div>
                      </li>
                    ): null)}
                    </ul>

                    <h2>フィットネス&スポーツ</h2>
                    <ul className="box_covid nohov">
                    {(this.state.sports_and_fitness ? (
                      <li>
                        <div className="name">{this.state.sports_and_fitness.unit.name}</div>
                        <div className="typetitle" onClick={this.showWin02}>あなたの筋肉タイプからわかること</div>
                        {classifyType([55005], this.state.sports_and_fitness) ? (TypeLink("速筋型", "-fast")) : null }
                        {classifyType([55003], this.state.sports_and_fitness) ? (TypeLink("バランス型", "-balance")) : null }
                        {classifyType([55001], this.state.sports_and_fitness) ? (TypeLink("遅筋型", "-slow")) : null }
                        <div id="sports">
                            <p className="text_gray">
                            {classifyType([55005], this.state.sports_and_fitness) ? muscleText().fast : null }
                            {classifyType([55003], this.state.sports_and_fitness) ? muscleText().balance : null }
                            {classifyType([55001], this.state.sports_and_fitness) ? muscleText().slow : null }
                            <br/><br/>
                            <Link
                              onClick={this.handleClickOpen.bind(this, this.state.sports_and_fitness.unit.id)}
                              to={{
                                pathname: "/detail",
                                state: { referer: "/covid" }
                              }}>
                              結果を見る
                            </Link>
                            </p>
                        </div>
                      </li>
                    ) :null)}
                    </ul>
                  </div>
                </div>
              </div>
                </div>
              )}
            </div>
          </div>
          <div className={this.state.winOpen ? 'modalwin' : 'modalwin -open'}>
            <div className="overlay" onClick={this.showWin}>
            <div className="textmodal" onClick={(e) => e.stopPropagation()}>
              <div onClick={this.showWin} className="closebtn"><img src="/image/covid/del.svg" alt="" /></div>
              <h3>あなたの遺伝子型ダイエットタイプから学びましょう</h3>
              <p>炭水化物、脂質、たんぱく質といった栄養素の代謝に関わるあなたの遺伝子の傾向を知り対策することが、体重管理に役立ちます。<br /><br />
コロナ禍で外出の自粛など活動が制限される生活において、食事偏りを調整することで免疫能を維持することができます。</p>
            </div>
            </div>
          </div>

          <div className={this.state.winOpen02 ? 'modalwin' : 'modalwin -open'}>
            <div className="overlay" onClick={this.showWin02}>
            <div className="textmodal" onClick={(e) => e.stopPropagation()}>
              <div onClick={this.showWin02} className="closebtn"><img src="/image/covid/del.svg" alt="" /></div>
              <h3>あなたの筋肉タイプからわかること</h3>
              <p>筋肉のタイプを知ることで、遺伝的な筋肉の特性にあった運動を行うこごができます。<br /><br />これにより、外出の自粛といった行動が制限されているコロナ禍でも最適なトレーニングやフィットネスを調整できます。 </p>
            </div>
            </div>
          </div>

          <div className={this.state.winOpen03 ? 'modalwin' : 'modalwin -open'}>
            <div className="overlay" onClick={this.showWin03}>
            <div className="textmodal" onClick={(e) => e.stopPropagation()}>
              <div onClick={this.showWin03} className="closebtn"><img src="/image/covid/del.svg" alt="" /></div>
              <h3>遺伝子とCOVID-19</h3>
              <p>COVID-19に関する研究はまだ発展段階であり、研究者はなおもヒトの遺伝子とCOVID-19重症化の関係を調査しているところです。<br /><br />

初期段階の研究では、ヒトの抗ウイルス防御に関連するI型インターフェロン（IFN）免疫が、COVID-19に関連している可能性があることが示されました。ですが、重症化を決定する単一の遺伝的要因はありません。<br /><br />

本件に関する研究はまだ進行中であり、特にこの研究は独立して再現されていないということにご留意ください。 そのため、レポートはあくまで目安となります。</p>
            </div>
            </div>
          </div>

          </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/Covid19.js